import { httpRequest } from "../../http";
import { Launch } from "@models/launch.model";
import { LaunchSerializer } from "@models/serializers/launchSerializer";

export class CommandLinkLaunchOrganization {
  async run(launchId: number, organizationId: number): Promise<Launch> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/link/`;
    const response = await httpRequest<any>(url, {
      method: "POST",
      body: JSON.stringify({ organization_id: organizationId }),
    });

    const serializer = new LaunchSerializer();
    return serializer.deserialize(response);
  }
}
